// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__18JYr","footer":"ModalFilter_footer__3M3uI"};